import React from "react";
import { Link } from "react-router-dom";
import guLocale from "../locales/gu";

const CMSForm = ({cmsData}) => {
  const locale = guLocale.cms.callUs;
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">{cmsData?.title}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">{locale.home}</Link>
                  </li>
                  <li className="breadcrumb-item active">{cmsData?.title}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="card card-solid">
            <div className="card-body">
              <div className="row">
                <div className="tab-content p-3">
                  <div className="tab-pane fade show active">
                    <div dangerouslySetInnerHTML={{ __html: cmsData?.content }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CMSForm;
